import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App.tsx';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './features/auth/providers/auth-provider.tsx';
import { ProfileProvider } from './features/auth/providers/profile-provider.tsx';

import ErrorPage from './routes/Error.tsx';
import Dashboard from './routes/Dashboard.tsx';
import InitialCheckForm from './routes/InitialCheckForm.tsx';
import ErneutePruefung from './routes/ErneutePruefung.tsx';
import Orders from './routes/Orders.tsx';
import Profile from './routes/Profile.tsx';
import ProfileSettings from './routes/ProfileSettings.tsx';
import PasswordForgot from './routes/PasswordForgot.tsx';
import PasswordReset from './routes/PasswordReset.tsx';
import Documentcenter from './routes/Documentcenter.tsx';
import AccountActivation from './routes/AccountActivation.tsx';
import AccountActivateToken from './routes/AccountActivateToken.tsx';
import Registration from './routes/Registration.tsx';
import RegistrationConfirm from './routes/RegistrationConfirm.tsx';
import PageTitle from './features/functions/title.tsx';

import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";

const routes = {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
        {
            protected: true,
            path: "/",
            element: <><PageTitle title={'Home'} /><Dashboard /></>
        },
        {
            protected: true,
            path: "/profile",
            element: <><PageTitle title={'Profil'} /><Profile /></>
        },
        {
            protected: true,
            path: "/profile/:active",
            element: <Profile />
        },
        {
            protected: true,
            path: "/profile/:active/:addition",
            element: <Profile />
        },
        {
            protected: true,
            path: "/profile/settings",
            element: <><PageTitle title={'Kontoeinstellungen'} /><ProfileSettings /></>
        },
        {
            protected: true,
            path: "/erstpruefung",
            element: <><PageTitle title={'Erstprüfung'} /><InitialCheckForm /></>
        },
        {
            protected: true,
            path: "/erneute-pruefung",
            element: <><PageTitle title={'Erneute Prüfung'} /><ErneutePruefung /></>
        },
        {
            protected: true,
            path: "/auftraege",
            element: <><PageTitle title={'Aufträge'} /><Orders /></>
        },
        {
            protected: false,
            path: "/password-forgot",
            element: <><PageTitle title={'Passwort vergessen'} /><PasswordForgot /></>
        },
        {
            protected: false,
            path: "/reset-pw/:token",
            element: <><PageTitle title={'Passwort zurücksetzen'} /><PasswordReset /></>
        },
        {
            protected: true,
            path: "/dokumentencenter",
            element: <><PageTitle title={'Dokumentencenter'} /><Documentcenter /></>
        },
        {
            protected: false,
            path: "/konto-aktivieren",
            element: <><PageTitle title={'Konto aktivieren'} /><AccountActivation /></>
        },
        {
            protected: false,
            path: "/activate/:token",
            element: <><PageTitle title={'Konto aktivieren'} /><AccountActivateToken /></>
        },
        {
            protected: false,
            path: "/registrierung",
            element: <><PageTitle title={'Registrierung'} /><Registration /></>
        },
        {
            protected: false,
            path: "/registrierung-bestaetigen/:token",
            element: <><PageTitle title={'Registrierung bestätigen'} /><RegistrationConfirm /></>
        },
    ]
}

const router = createBrowserRouter([routes]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <ProfileProvider>
                <RouterProvider router={router} />
            </ProfileProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export const getRoutes = () => {
    return routes.children;
}
